import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useValueRef } from 'design-system/client';
import { useMemo } from 'react';
import getSWRMiddleware from './getSWRMiddleware';
import type { UseApiOptions } from './types';
function defaultSelector<T>(data: T): T {
  return data;
}
export function useUseApiCommonLogic(options) {
  const $ = _c(12);
  const fetchOptionsRef = useValueRef(options?.fetchOptions);
  const debounceMs = options?.debounceMs;
  const intervalMs = options?.intervalMs;
  const beforeRef = useValueRef(options?.before);
  const afterRef = useValueRef(options?.after);
  const selectorRef = useValueRef(options?.selector ?? defaultSelector);
  let t0;
  if ($[0] !== options) {
    t0 = options?.skipIf?.() ?? false;
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const skip = t0;
  let t1;
  if ($[2] !== afterRef || $[3] !== beforeRef || $[4] !== debounceMs || $[5] !== selectorRef) {
    t1 = getSWRMiddleware(beforeRef, afterRef, selectorRef, debounceMs);
    $[2] = afterRef;
    $[3] = beforeRef;
    $[4] = debounceMs;
    $[5] = selectorRef;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const middleware = t1;
  let t2;
  if ($[7] !== fetchOptionsRef || $[8] !== intervalMs || $[9] !== middleware || $[10] !== skip) {
    t2 = {
      middleware,
      skip,
      intervalMs,
      fetchOptionsRef
    };
    $[7] = fetchOptionsRef;
    $[8] = intervalMs;
    $[9] = middleware;
    $[10] = skip;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}